export enum TopActions {
  Category,
  Date,
  Memo,
  Tags,
}

export enum BottomActions {
  MerchantBudget,
  SplitTransaction,
  HideTransaction,
  MerchantLogo,
}

export const DEFAULT_TOP_ACTIONS = [
  TopActions.Category,
  TopActions.Date,
  TopActions.Memo,
  TopActions.Tags,
] as TopActions[]

export const DEFAULT_BOTTOM_ACTIONS = [
  BottomActions.SplitTransaction,
  BottomActions.HideTransaction,
  BottomActions.MerchantLogo,
] as BottomActions[]

export const CHEVRON_ICON_SIZE = 20
export const ICON_SIZE = 28
